import React, { useCallback } from 'react';
import ReportHeader from '../../components/reports/shared/report-header';
import ValuesFitResults from '../../components/reports/shared/results/values-fit-results';
import PersonalityAcumenResults from '../../components/reports/shared/results/personality-acumen-results';
import ExperienceJudgmentResults from '../../components/reports/shared/results/experience-judgment-results';
import CompetenciesJudgmentTips from '../../components/reports/shared/tips/competencies-judgment-tips';
import RecommendationsPersonalityTips from '../../components/reports/shared/tips/recommendations-personality-tips';
import { INDIVIDUAL_VALUE_TIPS } from '../../components/reports/shared/tips/acumen-values-experience-tips';
import ReportPdfHeader from '../../components/reports/shared/report-pdf-header';
import LeaderCompetenciesStrengthsWeaknesses from '../../components/reports/leader/leader-competencies-alignment-strengths-weaknesses';
import LeaderDevelopmentTipsIntro from '../../components/reports/leader/leader-development-tips-intro';
import PagedAcumenValuesExperienceTips from '../../components/reports/shared/tips/paged-acumen-values-experience-tips';
import LeaderReportSummary from '../../components/reports/leader/leader-report-summary';
import LeaderCompetenciesSummary from '../../components/reports/leader/leader-competencies-summary';
import { generateCompetenciesCommentsPdfPages } from '../../components/reports/shared/report-util';
import LeaderConfidentialPage from '../../components/reports/leader/leader-confidential-page';
import LeaderInstructionsPage1 from '../../components/reports/leader/leader-instructions-page-1';
import LeaderInstructionsPage2 from '../../components/reports/leader/leader-instructions-page-2';
import { PRODUCT_CLASSIFICATION, REPORT_TYPE } from '../../utils/constants';
import { FeedbackReport } from '../../components/reports/shared/results/feedback-report';

function LeaderDevelopmentReport({ candidate, creatingPdf }) {
  const openEndedCommentsPages = useCallback(() => {
    return generateCompetenciesCommentsPdfPages(creatingPdf, candidate);
  }, [candidate, creatingPdf]);

  return (
    <>
      <div className="print-page">
        <LeaderConfidentialPage candidate={candidate} />
      </div>
      <div className="print-page">
        <LeaderInstructionsPage1 />
      </div>
      <div className="print-page">
        <LeaderInstructionsPage2 />
      </div>
      <FeedbackReport candidate={candidate} reportType={REPORT_TYPE.development} creatingPdf={creatingPdf} />
      <div className="print-page print-heading">
        <ReportPdfHeader />
        <ReportHeader candidate={candidate} header="Leader's Development Report" />
        <LeaderReportSummary candidate={candidate} speedometers={false} isDevelopment={true} />
        <PersonalityAcumenResults candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <ValuesFitResults candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <ExperienceJudgmentResults candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <LeaderCompetenciesSummary candidate={candidate} />
      </div>
      <div className="print-page">
        <LeaderCompetenciesStrengthsWeaknesses candidate={candidate} withComments={!creatingPdf} />
      </div>
      {openEndedCommentsPages()}
      <div className="print-page">
        <RecommendationsPersonalityTips
          candidate={candidate}
          withAcumen={true}
          classification={PRODUCT_CLASSIFICATION.develop}
          tipsIntro={<LeaderDevelopmentTipsIntro />}
          reportType={REPORT_TYPE.development}
        />
      </div>
      <PagedAcumenValuesExperienceTips
        candidate={candidate}
        valuesTips={INDIVIDUAL_VALUE_TIPS}
        classification={PRODUCT_CLASSIFICATION.develop}
        withAcumen={false}
        topFourMisAligned={true}
        creatingPdf={creatingPdf}
        reportType={REPORT_TYPE.development}
      />
      <div className="print-page">
        <CompetenciesJudgmentTips candidate={candidate} nTips={1} reportType={REPORT_TYPE.development} />
      </div>
    </>
  );
}

export default LeaderDevelopmentReport;
